import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { removeUndefined } from 'na-lib';
import { SettingsService } from 'src/app/service/settings.service';

@Component({
    selector: '[app-widget-styling]',
    templateUrl: './widget-styling.component.html',
    styleUrls: ['./widget-styling.component.css'],
    standalone: false
})

export class WidgetStylingComponent {
  @Input('app-widget-styling') data:any;
  @Output() returnChanges = new EventEmitter<{newStyle: any, widget: any, widgetId:string}>()
  widgetStyleForm!:FormGroup
  widgetStyleData:any = {}
  colorPalette:any=[]
  widgetType:any

  // invalid colors
  invalid_lightBackground = false
  invalid_darkBackground = false
  invalid_lightTitle = false
  invalid_darkTitle = false
  invalid_lightSubtitle = false
  invalid_darkSubtitle = false
  invalid_lightPrimary = false
  invalid_darkPrimary = false
  invalid_lightAccent = false
  invalid_darkAccent = false

  // theme style colors
  lightBackground=false 
  lightTitle=false
  lightSubtitle=false
  lightPrimary=false
  lightAccent=false
  darkBackground=false
  darkTitle=false
  darkSubtitle=false
  darkPrimary=false
  darkAccent=false

  //other 
  lightbackgroundImageURL=false
  darkbackgroundImageURL=false

  lightbackgroundImageAnchor=false
  darkbackgroundImageAnchor=false
  contentAlignment= false
  fontName=false
  fontUrl=false

  backgroundImageURL = false
  backgroundImageAnchor = false

  paddingTop = false
  paddingBottom = false
  translationMode = false
  userHasBetaWidgetRole = false

  colorLabels = {
    background: 'pass.styleLabel.background',
    title: 'pass.styleLabel.title',
    subtitle: 'pass.styleLabel.subtitle',
    primary: 'pass.styleLabel.plainText',
    accent: 'pass.styleLabel.links'
  }

  anchorOptions = [
    {
      type:'topLeft',
      translate:'pass.anchorOptions.topLeft',
    },
    {
      type:'topCenter',
      translate:'pass.anchorOptions.topCenter',
    },
    {
      type:'topRight',
      translate:'pass.anchorOptions.topRight',
    },
    {
      type:'left',
      translate:'pass.anchorOptions.left',
    },
    {
      type:'center',
      translate:'pass.anchorOptions.center',
    },
    {
      type:'right',
      translate:'pass.anchorOptions.right',
    },
    {
      type:'bottomLeft',
      translate:'pass.anchorOptions.bottomLeft',
    },
    {
      type:'bottomCenter',
      translate:'pass.anchorOptions.bottomCenter',
    },
    {
      type:'bottomRight',
      translate:'pass.anchorOptions.bottomRight',
    }
  ]

  constructor(public dialogRef: MatDialogRef<WidgetStylingComponent>,
    private fb: FormBuilder,
    private settingsService: SettingsService){}

    ngOnInit(): void{
      if(this.settingsService.checkIfBetaRoleAccess())
        this.userHasBetaWidgetRole = true

      this.translationMode = this.data?.widgetData ? this.data.widgetData.translateMode : false

      this.widgetType = this.data.form?.type
      this.initializePaletteColors()

      if(this.data.form?.widgetStyle)
        this.widgetStyleData = this.data.form.widgetStyle

        switch(this.data.form?.type){
          case 'annotatedMap':{

            this.lightBackground=false
            this.lightTitle=false
            this.lightSubtitle=false
            this.lightPrimary=false
            this.lightAccent=true
            this.darkBackground=false
            this.darkTitle=false
            this.darkSubtitle=false
            this.darkPrimary=false
            this.darkAccent=true

            this.lightbackgroundImageURL=false
            this.darkbackgroundImageURL=false
            this.backgroundImageAnchor = false
            this.contentAlignment=false
            this.fontName=true
            this.fontUrl=true

            this.colorLabels.subtitle = 'pass.styleLabel.subtitle'
            this.colorLabels.primary = 'pass.styleLabel.contentText'
            break;
          }

          case 'buttons':{
            this.lightBackground=false
            this.lightTitle=true
            this.lightSubtitle=true
            this.lightPrimary=true
            this.lightAccent=true
            this.darkBackground=false
            this.darkTitle=true
            this.darkSubtitle=true
            this.darkPrimary=true
            this.darkAccent=true

            this.lightbackgroundImageURL=false
            this.darkbackgroundImageURL=false
            this.backgroundImageAnchor = false
            this.contentAlignment= true
            this.fontName=true
            this.fontUrl=true
            break;
          }

          case 'composed':{
            this.lightBackground=false
            this.lightTitle=false
            this.lightSubtitle=false
            this.lightPrimary=false
            this.lightAccent=true
            this.darkBackground=false
            this.darkTitle=false
            this.darkSubtitle=false
            this.darkPrimary=false
            this.darkAccent=true

            this.lightbackgroundImageURL=false
            this.darkbackgroundImageURL=false
            this.contentAlignment=true
            this.fontName=true
            this.fontUrl=true

            this.colorLabels.subtitle = 'pass.styleLabel.subtitle'
            this.colorLabels.primary = 'pass.styleLabel.contentText'
            break;
          }
          
          case 'countdown':{

            this.lightBackground=false
            this.lightTitle=true
            this.lightSubtitle=true
            this.lightPrimary=true
            this.lightAccent=true
            this.darkBackground=false
            this.darkTitle=true
            this.darkSubtitle=true
            this.darkPrimary=true
            this.darkAccent=true

            this.lightbackgroundImageURL=false
            this.darkbackgroundImageURL=false
            this.backgroundImageAnchor = false
            this.contentAlignment=true
            this.fontName=true
            this.fontUrl=true
            break;
          }

          case 'form':{

            this.lightBackground=false
            this.lightTitle=false
            this.lightSubtitle=false
            this.lightPrimary=false
            this.lightAccent=false
            this.darkBackground=false
            this.darkTitle=false
            this.darkSubtitle=false
            this.darkPrimary=false
            this.darkAccent=false

            this.lightbackgroundImageURL=false
            this.darkbackgroundImageURL=false
            this.backgroundImageAnchor = false
            this.contentAlignment= false
            this.fontName=true
            this.fontUrl=true

            this.colorLabels.subtitle = 'pass.styleLabel.subtitle'
            this.colorLabels.primary = 'pass.styleLabel.primaryTextColor'
            this.colorLabels.accent = 'pass.styleLabel.booleanColor'
            break;
          }

          case 'image':{
            this.lightBackground=false
            this.lightTitle=false
            this.lightSubtitle=false
            this.lightPrimary=true
            this.lightAccent=true
            this.darkBackground=false
            this.darkTitle=false
            this.darkSubtitle=false
            this.darkPrimary=true
            this.darkAccent=true

            this.lightbackgroundImageURL=false
            this.darkbackgroundImageURL=false
            this.backgroundImageAnchor = false
            this.contentAlignment= false
            this.fontName=true
            this.fontUrl=true

            break;
          }

          case 'images':{
            this.lightBackground=false
            this.lightTitle=false
            this.lightSubtitle=false
            this.lightPrimary=false
            this.lightAccent=true
            this.darkBackground=false
            this.darkTitle=false
            this.darkSubtitle=false
            this.darkPrimary=false
            this.darkAccent=true

            this.lightbackgroundImageURL=false
            this.darkbackgroundImageURL=false
            this.backgroundImageAnchor= false
            this.contentAlignment= false
            this.fontName=true
            this.fontUrl=true

            this.colorLabels.primary = 'pass.styleLabel.imageTitles'
            break;
          }

          case 'productRegistration':{
            this.lightBackground=false
            this.lightTitle=true
            this.lightSubtitle=true
            this.lightPrimary=true
            this.lightAccent=true
            this.darkBackground=false
            this.darkTitle=true
            this.darkSubtitle=true
            this.darkPrimary=true
            this.darkAccent=true

            this.lightbackgroundImageURL=false
            this.darkbackgroundImageURL=false
            this.backgroundImageAnchor = false
            this.contentAlignment= true
            this.fontName=true
            this.fontUrl=true
            break;
          }

          case 'spacer':{
            this.lightBackground=false
            this.lightTitle=true
            this.lightSubtitle=true
            this.lightPrimary=true
            this.lightAccent=true
            this.darkBackground=false
            this.darkTitle=true
            this.darkSubtitle=true
            this.darkPrimary=true
            this.darkAccent=true

            this.lightbackgroundImageURL=false
            this.darkbackgroundImageURL=false
            this.backgroundImageAnchor = false
            this.contentAlignment= true
            this.fontName=true
            this.fontUrl=true
            break;
          }

          case 'text':{
            this.lightBackground=false
            this.lightTitle=false
            this.lightSubtitle=false
            this.lightPrimary=false
            this.lightAccent=false
            this.darkBackground=false
            this.darkTitle=false
            this.darkSubtitle=false
            this.darkPrimary=false
            this.darkAccent=false

            this.lightbackgroundImageURL=false
            this.darkbackgroundImageURL=false
            this.backgroundImageAnchor = false
            this.contentAlignment=true
            this.fontName=true
            this.fontUrl=true
            break;
          }

          case 'video':{
            this.lightBackground=false
            this.lightTitle=false
            this.lightSubtitle=false
            this.lightPrimary=true
            this.lightAccent=true
            this.darkBackground=false
            this.darkTitle=false
            this.darkSubtitle=false
            this.darkPrimary=true
            this.darkAccent=true

            this.lightbackgroundImageURL=false
            this.darkbackgroundImageURL=false
            this.backgroundImageAnchor = false
            this.contentAlignment= false
            this.fontName=true
            this.fontUrl=true

            this.colorLabels.subtitle = 'pass.styleLabel.subtitle'
            break;
          }

        }

      const { lightColors, darkColors , contentAlignment, font, padding, backgroundImageAnchor } = this.widgetStyleData
      this.widgetStyleForm = this.fb.group({

        lightBackground: {value:lightColors?.background ? lightColors?.background : undefined, disabled: this.lightBackground}, 
        darkBackground:{value:darkColors?.background ? darkColors?.background : undefined, disabled: this.darkBackground},

        lightTitle: {value:lightColors?.title ? lightColors?.title : undefined, disabled: this.lightTitle}, 
        darkTitle:{value:darkColors?.title ? darkColors?.title : undefined, disabled: this.darkTitle},

        lightSubtitle: {value:lightColors?.subtitle ? lightColors?.subtitle : undefined, disabled: this.lightSubtitle}, 
        darkSubtitle:{value:darkColors?.subtitle ? darkColors?.subtitle : undefined, disabled: this.darkSubtitle},

        lightPrimary: {value:lightColors?.primary ? lightColors?.primary : undefined, disabled: this.lightPrimary}, 
        darkPrimary:{value:darkColors?.primary ? darkColors?.primary : undefined, disabled: this.darkPrimary},

        lightAccent: {value:lightColors?.accent ? lightColors?.accent : undefined, disabled: this.lightAccent}, 
        darkAccent:{value:darkColors?.accent ? darkColors?.accent : undefined, disabled: this.darkAccent},

        lightbackgroundImageURL: {value:lightColors?.backgroundImageURL ? lightColors?.backgroundImageURL : undefined, disabled: this.lightbackgroundImageURL},
        // lightbackgroundImageAnchor: {value: lightColors?.backgroundImageAnchor ? lightColors?.backgroundImageAnchor : 'topLeft', disabled: this.lightbackgroundImageAnchor},

        darkbackgroundImageURL: {value:darkColors?.backgroundImageURL ? darkColors?.backgroundImageURL : undefined, disabled: this.darkbackgroundImageURL},
        // darkbackgroundImageAnchor: {value: darkColors?.backgroundImageAnchor ? darkColors?.backgroundImageAnchor : 'topLeft', disabled: this.darkbackgroundImageAnchor},

        backgroundImageAnchor: {value: backgroundImageAnchor ? backgroundImageAnchor : 'topLeft', disabled: this.lightbackgroundImageAnchor},

        paddingTop: {value: padding?.top ? padding?.top : undefined, disabled:this.paddingTop},
        paddingBottom: {value: padding?.bottom ? padding?.bottom : undefined, disabled:this.paddingBottom},

        contentAlignment: {value:contentAlignment ? contentAlignment : undefined, disabled:this.contentAlignment}, 

        fontName:{value:font?.name ? font?.name : undefined, disabled: this.fontName}, 
        fontUrl:{value:font?.url ? font?.url : undefined, disabled: this.fontUrl}
      })

      this.widgetStyleForm.valueChanges.subscribe( value => {
        const newStyle = this.getfomatedDataStyling(value)
        if(!this.translationMode)
          this.returnChanges.emit({newStyle: newStyle, widget: this.data.form, widgetId: this.data.form.id})
      })

    }

    getfomatedDataStyling(data){
      let {
        lightBackground,
        lightTitle,
        lightSubtitle,
        lightPrimary,
        lightAccent,

        darkBackground,
        darkTitle,
        darkSubtitle,
        darkPrimary,
        darkAccent,

        lightbackgroundImageURL,
        darkbackgroundImageURL,

        // lightbackgroundImageAnchor,
        // darkbackgroundImageAnchor,

        contentAlignment,
        paddingBottom,
        paddingTop,
        backgroundImageAnchor,
        fontName,
        fontUrl
      } = data

      // if(lightbackgroundImageAnchor && lightbackgroundImageAnchor == 'topLeft')
      // lightbackgroundImageAnchor = undefined

      // if(darkbackgroundImageAnchor && darkbackgroundImageAnchor == 'topLeft')
      // darkbackgroundImageAnchor = undefined

      if(backgroundImageAnchor && backgroundImageAnchor == 'topLeft')
      backgroundImageAnchor = undefined

      let style = {
        lightColors:{
          background: lightBackground ? lightBackground :undefined,
          title: lightTitle ? lightTitle :undefined,
          subtitle: lightSubtitle ? lightSubtitle :undefined,
          primary: lightPrimary ? lightPrimary :undefined,
          accent: lightAccent ? lightAccent :undefined,
          backgroundImageURL: lightbackgroundImageURL ? lightbackgroundImageURL : undefined,
          // backgroundImageAnchor: lightbackgroundImageAnchor ? lightbackgroundImageAnchor : undefined,
        },
        darkColors: {
          background: darkBackground ? darkBackground :undefined,
          title: darkTitle ? darkTitle :undefined,
          subtitle: darkSubtitle ? darkSubtitle :undefined,
          primary: darkPrimary ? darkPrimary :undefined,
          accent: darkAccent ? darkAccent :undefined,
          backgroundImageURL: darkbackgroundImageURL ? darkbackgroundImageURL : undefined,
          // backgroundImageAnchor: darkbackgroundImageAnchor ? darkbackgroundImageAnchor : undefined,
        },
        padding:{
          bottom: paddingBottom ? paddingBottom : undefined,
          top: paddingTop ? paddingTop : undefined
        },
        backgroundImageAnchor: backgroundImageAnchor ? backgroundImageAnchor : undefined,
        contentAlignment: contentAlignment ? contentAlignment :undefined,
        // font: {
        //   name: fontName ? fontName : undefined,
        //   url: fontUrl ? fontUrl : undefined
        // }
      }

      if(style && style.darkColors && style.darkColors['backgroundColor'])
      delete style.darkColors['backgroundColor']

      if(style && style.lightColors && style.lightColors['backgroundColor'])
      delete style.lightColors['backgroundColor']

      if(style && style.darkColors && style.darkColors['foregroundColor'])
      delete style.darkColors['foregroundColor']

      if(style && style.lightColors && style.lightColors['foregroundColor'])
      delete style.lightColors['foregroundColor']

      // if(style?.darkColors?.backgroundImageAnchor && !style?.darkColors?.backgroundImageURL)
      // delete style?.darkColors?.backgroundImageAnchor

      if(style && style['dark'])
      delete style['dark']

      if(style && style['light'])
      delete style['light']

      // if(!style.font?.name || !style.font?.url)
      //   delete style.font

      let cleaned = removeUndefined(style)

      if(Object.keys(cleaned.lightColors)?.length == 0)//(!lightBackground && !lightTitle && !lightSubtitle && !lightPrimary && !lightAccent && !lightbackgroundImageURL)
        delete cleaned.lightColors
        
      if(Object.keys(cleaned.darkColors)?.length == 0)//(!darkBackground && !darkTitle && !darkSubtitle && !darkPrimary && !darkAccent && !darkbackgroundImageURL )//
        delete cleaned.darkColors

      if(Object.keys(cleaned.padding)?.length == 0)//(!darkBackground && !darkTitle && !darkSubtitle && !darkPrimary && !darkAccent && !darkbackgroundImageURL )//
        delete cleaned.padding

      if(cleaned && Object.keys(cleaned)?.length==0)
      cleaned = undefined
        
      return cleaned
    }


    initializePaletteColors(){
      var colors=[]
      const warmOrange= getComputedStyle(document.documentElement).getPropertyValue('--warmOrange')
      const darkblue= getComputedStyle(document.documentElement).getPropertyValue('--darkBlue')
      const pureWhite= getComputedStyle(document.documentElement).getPropertyValue('--pureWhite')
      const neutral= getComputedStyle(document.documentElement).getPropertyValue('--neutral')
      colors.push(warmOrange)
      colors.push(darkblue)
      colors.push(pureWhite)
      colors.push(neutral)
      this.colorPalette=colors
    } 

    checkValidColors(){

      //-----backgroundColor
      this.invalid_lightBackground=this.widgetStyleForm.controls['lightBackground'].hasError('invalidColor')
      this.invalid_darkBackground=this.widgetStyleForm.controls['darkBackground'].hasError('invalidColor')
  
      //-----title
      this.invalid_lightTitle=this.widgetStyleForm.controls['lightTitle'].hasError('invalidColor')
      this.invalid_darkTitle=this.widgetStyleForm.controls['darkTitle'].hasError('invalidColor')
  
      //-----subtitle
      this.invalid_lightSubtitle=this.widgetStyleForm.controls['lightSubtitle'].hasError('invalidColor')
      this.invalid_darkSubtitle=this.widgetStyleForm.controls['darkSubtitle'].hasError('invalidColor')
  
      //-----primary
      this.invalid_lightPrimary=this.widgetStyleForm.controls['lightPrimary'].hasError('invalidColor')
      this.invalid_darkPrimary=this.widgetStyleForm.controls['darkPrimary'].hasError('invalidColor')
  
      //-----accent
      this.invalid_lightAccent=this.widgetStyleForm.controls['lightAccent'].hasError('invalidColor')
      this.invalid_darkAccent=this.widgetStyleForm.controls['darkAccent'].hasError('invalidColor')
    }

    resetLightColors(){
      this.widgetStyleForm.patchValue({
        lightBackground: undefined, 
        lightTitle: undefined, 
        lightSubtitle:undefined, 
        lightPrimary: undefined, 
        lightAccent: undefined, 
      })
    }
  
    resetDarkColors(){
      this.widgetStyleForm.patchValue({
        darkBackground:undefined,
        darkTitle:undefined,
        darkSubtitle:undefined,
        darkPrimary:undefined,
        darkAccent:undefined,
      })
    }
}
